export const lookupMixin = {
  data() {
    return {
      suggestions: null,
    };
  },
  computed:{
    getSuggestedFieldName() {
      return this.item &&  this.item[`${this.field.name}__$LookupStatus`];
    },
    isSuggestionsExist() {
      return this.getSuggestedFieldName
          && this.getSuggestedFieldName.Suggestions
          && !!this.getSuggestedFieldName.Suggestions.length ;
    },
    getItemSuggestions() {
      return this.getSuggestedFieldName.Suggestions.map(el => ({
        ...el,
        id: el.RecordGuid,
        text: el.SuggestedValue,
      }));
    },
  },
  methods: {
    isValidSuggestions(suggestionName) {
      if (suggestionName) {
        const suggestions = suggestionName.Suggestions || suggestionName.suggestions;
        return suggestions && suggestions.length > 0;
      }
      return false;
    },
  },
};